module.exports = __webpack_public_path__ + "static/media/documentation_training.9c56f1c3.png";